"use strict";

var _defineProperty2 = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _objectWithoutProperties = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _classCallCheck = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _excluded = ["cell"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _FormCell = _interopRequireDefault(require("./FormCell"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var EmailFormCell = /*#__PURE__*/function (_react$default$PureCo) {
  function EmailFormCell() {
    _classCallCheck(this, EmailFormCell);
    return _callSuper(this, EmailFormCell, arguments);
  }
  _inherits(EmailFormCell, _react$default$PureCo);
  return _createClass(EmailFormCell, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        cell = _this$props.cell,
        otherProps = _objectWithoutProperties(_this$props, _excluded);
      var intl = this.props.intl;
      var firstNameLabel = intl.formatMessage({
        id: 'email_form.first_name.label'
      });
      var lastNameLabel = intl.formatMessage({
        id: 'email_form.last_name.label'
      });
      var ageLabel = intl.formatMessage({
        id: 'email_form.age.label'
      });
      var genderLabel = intl.formatMessage({
        id: 'email_form.gender.label'
      });
      var emailLabel = intl.formatMessage({
        id: 'email_form.email.label'
      });
      var formCell = _objectSpread(_objectSpread({}, cell), {}, {
        fields: [{
          name: "firstName",
          type: "short_text",
          label: firstNameLabel,
          half_width: true,
          required: false
        }, {
          name: "lastName",
          type: "short_text",
          label: lastNameLabel,
          half_width: true,
          required: false
        }, {
          name: "age",
          type: "integer",
          label: ageLabel,
          half_width: false,
          required: false
        }, {
          name: "gender",
          type: "gender",
          label: genderLabel,
          half_width: false,
          required: false
        }, {
          name: "email",
          type: "email",
          label: emailLabel,
          half_width: false,
          required: true
        }]
      });
      return /*#__PURE__*/_react.default.createElement(_FormCell.default, _extends({
        cell: formCell
      }, otherProps));
    }
  }]);
}(_react.default.PureComponent);
_defineProperty(EmailFormCell, "whyDidYouRender", true);
var _default = exports.default = (0, _reactIntl.injectIntl)(EmailFormCell);